import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionTopicDetails } from "./components/DigestionTopicDetails";

export function DigestionTopicPage() {
  return (
    <Page title="Digestion Topic Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionTopicDetails />
      </Container>
    </Page>
  );
}
